import { compose } from 'redux'
import { connect } from 'react-redux'
import { lifecycle, withState } from 'recompose'
import { reduxForm, initialize } from 'redux-form'
import { getLocationPathname, getLocationSearch } from 'selectors/getPageLocation'
import { getIsQuoteExist } from 'selectors/shoppingData'
import { isApptConfirmationPage, isQuoteSummaryPage } from 'helpers/quoteRelatedPages'
import { setAppointmentResponse, setQuickApptInitialized, setPreSelectedServices } from 'components/QuickAppointmentPage/actions'
import { get3StepperEnabled } from 'selectors/thirdPartyData'
import { APP_START_LOADING, APP_STOP_LOADING } from 'components/Main/actions'
import { getCartDetail } from 'components/ShoppingQuote/actions'
import { IsFromAppointmentConfirmationToQuote } from './helpers'
import { getInitialValues, getInitialValuesObject, getQuickAppointmentStepper } from './selectors'
import { APPOINTMENT_FORM_NAME, QUICK_APPOINTMENT_PAGE } from 'constant'
import Appointment from './Appointment'

const withComponentInitializedState = withState('componentInitialized', 'setComponentInitialized', false)

const mapStateToProps = state => {
  const pathname = getLocationPathname(state)
  const isQuoteApptConfirmationPage = isApptConfirmationPage(pathname)
    && getLocationSearch(state).startsWith('?isFromOnlineAppointment=false')
  const { app: { isFetching, isLoading }} = state

  return {
    state,
    isLoading,
    hideMainContent: isFetching || isLoading,
    quickAppointmentStepper: pathname === QUICK_APPOINTMENT_PAGE && getQuickAppointmentStepper(state),
    threeStepperEnabled: pathname === QUICK_APPOINTMENT_PAGE && get3StepperEnabled(state),
    isQuoteApptConfirmationPage,
    quotePageEnabled: isQuoteSummaryPage(pathname),
    cartStateExists: getIsQuoteExist(state),
    ...getInitialValues(state)
  }
}

const withReduxFormInitialize = lifecycle({
  // This fix resolve redux-form issue.
  // https://github.com/erikras/redux-form/issues/4152
  // Form is initialized and then destroyed
  // when navigated to from another page with same form name(quick-appointment, quote pages).
  componentDidMount() {
    const {
      state,
      initialize,
      setAppointmentResponse,
      setQuickApptInitialized,
      isQuoteApptConfirmationPage,
      getCartDetail,
      cartStateExists,
      startLoading
    } = this.props

    startLoading()
    cartStateExists && isQuoteApptConfirmationPage && getCartDetail()
    setAppointmentResponse(null)

    if (!IsFromAppointmentConfirmationToQuote(state)) {
      initialize(getInitialValuesObject(state))
      setQuickApptInitialized(true)
    } else {
      setQuickApptInitialized(true)
    }
  },
  componentDidUpdate({ cartStateExists: prevCartStateExists }) {
    const {
      isQuoteApptConfirmationPage,
      getCartDetail,
      cartStateExists,
      componentInitialized,
      setComponentInitialized,
      isLoading,
      stopLoading
    } = this.props

    if (prevCartStateExists !== cartStateExists && cartStateExists && isQuoteApptConfirmationPage) {
      getCartDetail()
        .then(() => {
          !componentInitialized && setComponentInitialized(true)
          isLoading && stopLoading()
        })
    } else {
      !componentInitialized && setComponentInitialized(true)
      isLoading && stopLoading()
    }
  },
  componentWillUnmount() {
    const { setQuickApptInitialized, setPreSelectedServices } = this.props
    setQuickApptInitialized(false)
    setPreSelectedServices([])
  }
})

export default compose(
  connect(mapStateToProps, {
    initialize,
    setAppointmentResponse,
    setQuickApptInitialized,
    setPreSelectedServices,
    getCartDetail,
    startLoading: APP_START_LOADING,
    stopLoading: APP_STOP_LOADING
  }),
  reduxForm({
    form: APPOINTMENT_FORM_NAME,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  }),
  withComponentInitializedState,
  withReduxFormInitialize
)(Appointment)
